import { __assign } from "tslib";
import { createSkillsApi } from './index';
import { createHttpTestKit } from '../http/test-kit';
import { createFakeDeleteResponder, createFakeGetResponder, createFakePostResponder, createFakePutResponder } from '../test-utils';
export var createSkillsApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createSkillsApi('', fakeHttp);
    // @ts-ignore - Ignore the error here, or handle wildcard ('*') param
    var testKit = {
        whenGetSkills: function () { return createFakeGetResponder(fakeHttp, '/skills'); },
        whenGetSpecificSkill: function (dto) { return createFakeGetResponder(fakeHttp, "/skills/" + dto.id); },
        whenDeleteSkill: function (dto) { return createFakeDeleteResponder(fakeHttp, "/skills/" + dto.id); },
        whenAddSkill: function (dto) { return createFakePostResponder(fakeHttp, '/skills')(dto); },
        whenUpdateAgentSkillsAssignment: function (dto) { return createFakePutResponder(fakeHttp, "/agents/" + dto.agentId + "/skillIds")({ skillIds: dto.assignedSkills }); },
        whenDeleteAgentSkills: function (dto) { return createFakeDeleteResponder(fakeHttp, "/agents/" + dto.id + "/skillIds"); }
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map